import { Component } from 'react'
import styled from 'styled-components'

import Column from './Column'
import { HorizontalAlignmentsPropTypes, SpacingPropTypes } from './PropTypes'
import withSpacing from './WithSpacing'

const StyledColumnSet = styled.div`
  display: flex;
  flex-direction: row;
`

interface ColumnSetProps {
  columns: unknown[]
  horizontalAlignment?: HorizontalAlignmentsPropTypes
  preserveFirstChildSpacing?: boolean
  registerInputCallback?(...args: unknown[]): unknown
  separator?: boolean
  spacing?: SpacingPropTypes
}

class ColumnSet extends Component<ColumnSetProps> {
  static displayName = 'ColumnSet'

  computeWeights(columns: any) {
    let totalWeight = 0
    const weights = {}

    columns.forEach((column: any) => {
      if (column.width == null) {
        column.width = 1
      }
      if (typeof column.width === 'number') {
        totalWeight += column.width
      }
    })

    columns.forEach((column: any, index: any) => {
      if (column.width == null) {
        column.width = 1
      }
      if (typeof column.width === 'number' && totalWeight > 0) {
        // @ts-expect-error
        weights[index] = (100 / totalWeight) * column.width
      }
    })

    return weights
  }

  render() {
    const { registerInputCallback, columns, preserveFirstChildSpacing } = this.props

    const weights = this.computeWeights(this.props.columns)

    return (
      <StyledColumnSet data-id="wg-columnset">
        {columns.map((column: any, index: any) => {
          return (
            <Column
              key={index}
              {...column}
              spacing={preserveFirstChildSpacing ? column.spacing : index === 0 ? 'none' : column.spacing}
              separator={preserveFirstChildSpacing ? column.separator : index === 0 ? false : column.separator}
              // @ts-expect-error
              computedWeight={weights[index]}
              registerInputCallback={registerInputCallback}
            />
          )
        })}
      </StyledColumnSet>
    )
  }
}

export default withSpacing(ColumnSet)
